import { render, staticRenderFns } from "./ClientPersonalData.vue?vue&type=template&id=d9a1af88"
import script from "./ClientPersonalData.vue?vue&type=script&lang=js"
export * from "./ClientPersonalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports